<div id="startup">
    <div class="container-loader">
        <div id="loader" class="m-4" *ngIf="isLoading">
            <div class="spinner-grow" style="width: 5rem; height: 5rem; 
            background-image: url(/assets/img/brand/alpuraAzHzMin.svg);" role="status"> </div>
        </div>
        <div class="m-4" *ngIf="!isLoading">
            <img src="/assets/img/brand/alpuraAzHzMin.svg" class="img-fluid"
                style="width: 5rem; height: 5rem; filter: grayscale(100%);            ">
        </div>
        <p [class.text-danger]="!isLoading">{{message}}</p>
        <ngb-progressbar *ngIf="isLoading" type="primary" [value]="progressValue" [striped]="true"
            [animated]="isLoading"></ngb-progressbar>
        <div *ngIf="!isLoading">
            <button class="btn btn-secondary m-2" (click)="reloadSession()">
                Regresar al login
            </button>
            <button class="btn btn-primary m-2" (click)="validateUser()">
                Reintentar
            </button>
        </div>
    </div>
</div>